import md5 from 'js-md5'

export const FIRST_NAME_MAX_LENGTH = 15;
export const LAST_NAME_MAX_LENGTH = 25;


export const RECIPIENT_NAME_MAX_LENGTH = 30;
export const CARD_NAME_MAX_LENGTH = 22;

export const ADDRESS_FULLNAME = 'fullName';
export const ADDRESS_FIRSTNAME = 'firstName';
export const ADDRESS_LASTNAME = 'lastName';
export const ADDRESS_STREET1 = 'street1';
export const ADDRESS_STREET2 = 'street2';
export const ADDRESS_CITY = 'city';
export const ADDRESS_STATE = 'state';
export const ADDRESS_POSTCODE = 'postalCode';
export const ADDRESS_COUNTRY = 'countryCode';
export const ADDRESS_EMAIL = 'email';
export const ADDRESS_PHONE = 'phoneNumber';

export const addressFieldNames = {
    ADDRESS_FULLNAME,
    ADDRESS_FIRSTNAME,
    ADDRESS_LASTNAME,
    ADDRESS_STREET1,
    ADDRESS_STREET2,
    ADDRESS_CITY,
    ADDRESS_STATE,
    ADDRESS_POSTCODE,
    ADDRESS_COUNTRY,
    ADDRESS_EMAIL,
    ADDRESS_PHONE
};

export const fieldKeys = Object.keys(addressFieldNames).map(key => addressFieldNames[key]);

export function getAddressHash(fieldValues) {
    const name = fieldValues[ADDRESS_FULLNAME]
        ? fieldValues[ADDRESS_FULLNAME]
        : `${fieldValues[ADDRESS_FIRSTNAME]}
        ${fieldValues[ADDRESS_LASTNAME]}`;
    const hashString = `${name}
    ${fieldValues[ADDRESS_STREET1]}
    ${fieldValues[ADDRESS_STREET2]}
    ${fieldValues[ADDRESS_CITY]}
    ${fieldValues[ADDRESS_STATE]}
    ${fieldValues[ADDRESS_POSTCODE]}
    ${fieldValues[ADDRESS_COUNTRY]}`;
    return md5(hashString.replace(/\s/g, '').toLowerCase());
}

/**
 * Replace the address fields with the hash of the stored address.
 *
 * If the address has not been stored it will return undefined.
 * @param fieldValues { object } A map containing the address fields & values.
 * @param hash { string } A string representing the hash of the concatenated address values
 * @param keyForHash { string } A string indicating the key under which the hash should be stored in in fieldValues
 * @returns { object } original fieldValues with addressHash added and any individual address fields removed
 */
export function replaceAddressWithHash(fieldValues, hash, keyForHash = 'addressHash') {
    const valuesWithoutAddressFields = {...fieldValues, [keyForHash]: hash};
    fieldKeys.forEach(fieldKey => delete valuesWithoutAddressFields[fieldKey]);
    return valuesWithoutAddressFields;
}
